import page from 'page'
import get from 'lodash/get'

// Import localized routes
import fr from './locales/fr/routes'
import en from './locales/en/routes'
import kr from './locales/kr/routes'
import cht from './locales/cht/routes'
import cn from './locales/cn/routes'
import jp from './locales/jp/routes'

// Import FR
import homeFR from './locales/fr/home'
import worldsFR from './locales/fr/worlds'
import mainFR from './locales/fr/main'

// Import EN
import homeEN from './locales/en/home'
import worldsEN from './locales/en/worlds'
import mainEN from './locales/en/main'

// Import KR
import homeKR from './locales/kr/home'
import worldsKR from './locales/kr/worlds'
import mainKR from './locales/kr/main'

// Import CHT
import homeCHT from './locales/cht/home'
import worldsCHT from './locales/cht/worlds'
import mainCHT from './locales/cht/main'

// Import CN
import homeCN from './locales/cn/home'
import worldsCN from './locales/cn/worlds'
import mainCN from './locales/cn/main'

// Import CN
import homeJP from './locales/jp/home'
import worldsJP from './locales/jp/worlds'
import mainJP from './locales/jp/main'

// Import routes -> modules list
import modules from './modules'

class Router {
  constructor() {
    this.locales = [
      { code: 'fr', file: fr },
      { code: 'en', file: en },
      { code: 'kr', file: kr },
      { code: 'cht', file: cht },
      { code: 'cn', file: cn },
      { code: 'jp', file: jp }
    ]

    this.routes = {}

    this.homeEN = homeEN

    this.localized = {
      en: {
        home: homeEN,
        world: worldsEN,
        main: mainEN
      },
      fr: {
        home: homeFR,
        world: worldsFR,
        main: mainFR
      },
      kr: {
        home: homeKR,
        world: worldsKR,
        main: mainKR
      },
      cht: {
        home: homeCHT,
        world: worldsCHT,
        main: mainCHT
      },
      cn: {
        home: homeCN,
        world: worldsCN,
        main: mainCN
      },
      jp: {
        home: homeJP,
        world: worldsJP,
        main: mainJP
      }
    }
  }

  /**
   * Start router
   */
  start() {
    this.sync()
    page.start({ click: false })
  }

  /**
   * Stop router
   */
  stop() {
    page.stop()
  }

  /**
   * Define app component for route callbacks
   * @param  {Component} app the app component
   */
  setApp(app) {
    this.app = app
  }

  preSync() {
    this.locales.map(locale => {
      const { file, code } = locale
      return Object.keys(file).map(key => {
        if (!this.routes[code]) {
          this.routes[code] = {}
        }
        return (this.routes[code][key] = file[key])
      })
    })
  }

  /**
   * Register routes and associated callbacks
   */
  sync() {
    this.locales.map(locale => {
      const { file } = locale

      return Object.keys(file).map(key => {
        return page(file[key], ctx => {
          const routeLocale =
            this.locales.filter(locale => locale.file === file)[0].code || 'fr'

          ctx.locale = routeLocale
          ctx.key = key
          this.currentPath = ctx.path
          this.ctx = ctx

          this.app.setPage(
            modules[key],
            ctx,
            key,
            ctx.params.param
              ? this.localized[routeLocale][key][ctx.params.param]
              : this.localized[routeLocale][key],
            this.localized[routeLocale].main
          )
        })
      })
    })
  }

  /**
   * Route to specified path
   * @param  {string} path the path to go to
   */
  goto(path, target) {
    if (path === this.currentPath) return
    const mailto = path.indexOf('mailto:') !== -1

    if (path.indexOf('://') === -1 && !mailto) {
      page((path.indexOf('/') === 0 ? '' : '/') + path)
    } else {
      if (target === '_blank') {
        window.open(path, '_blank')
      } else {
        window.location.href = path
      }
    }
  }

  redirect(path) {
    page.redirect(path)
  }

  /**
   * Replace route scheme with params
   * @param {String} route
   * @param {params} [params]
   * @return {string}
   */
  getRouteWithParams(route, params) {
    return Object.keys(params).reduce(
      (acc, key) =>
        acc.replace(new RegExp(':' + key + '(\\?|\\*)?', 'i'), params[key]),
      route
    )
  }

  getContext() {
    return this.ctx
  }

  /**
   * Get path with route name
   * @param {String} name
   * @param {params} [params]
   * @param {locale} [locale]
   * @return {string}
   */
  getRoute = (name, params, locale) => {
    const route = this.routes[locale][name]
    return params ? this.getRouteWithParams(route, params) : route
  }

  setLocale(locale, key) {
    this.app.setLocale()
  }

  getParams(doc) {
    switch (doc.type) {
      case 'articles':
        return {
          slug: get(doc, 'slug', ''),
          category: get(doc, 'category.slug', '')
        }
        return {
          slug: get(doc, 'slug', '')
        }
      default:
        return {}
    }
  }
}

export const router = new Router()



// WEBPACK FOOTER //
// ./src/router.js